import React from "react";
export function Story() {
  return <section id="historia" className="px-6 py-20 sm:py-28" data-id="element-122" data-mp="2smy76c0i9l59">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[5fr_7fr] lg:gap-20" data-id="element-123" data-mp="1ibnc7gnw9jbj">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-124" data-mp="1n2lu2koj6pgw">
          <p className="mb-4 text-sm font-semibold text-gold" data-id="element-125" data-mp="1n58cjfcympdw">Mi historia</p>
          <h2 className="font-serif text-[clamp(30px,4.5vw,46px)] font-bold leading-[1.15]" data-id="element-126" data-mp="1s1p0o9k5t3qz">
            De no saber nada a vivir 100% del marketing digital
          </h2>
        </div>
        <div className="max-w-2xl text-[17px] leading-[1.8] text-soft" data-id="element-127" data-mp="zem43mz1n33d">
          <p className="mb-5" data-id="element-128" data-mp="14c4gjnc9s0g4">
            Soy papá de dos nenas. Eso lo cambió todo. Cuando nacieron, me di cuenta de que quería estar presente de
            verdad, no perdido en un trabajo que me robaba el tiempo que ellas merecían.
          </p>
          <p className="mb-5" data-id="element-129" data-mp="2frjd4q0kgqap">
            Hace 4 años arranqué de cero en el marketing digital, sin audiencia, sin experiencia y sin saber nada de
            tecnología. Los primeros dos años fueron duros. Pero seguí, porque tenía un motivo claro.
          </p>
          <blockquote className="my-10 border-l-[3px] border-gold pl-6 font-serif text-[clamp(20px,2.4vw,24px)] italic leading-snug text-white" data-id="element-130" data-mp="142p6cqcztsh0">
            “Hoy manejo mi tiempo, viajo en moto cuando quiero y estoy con mi familia. Todo gracias a vender productos
            digitales.”
          </blockquote>
          <p className="mb-5" data-id="element-131" data-mp="q48wwrnqxnv6">
            El negocio digital me dio lo que ningún trabajo en relación de dependencia me podría dar:{" "}
            <strong className="font-semibold text-white" data-id="element-132" data-mp="laeavhko4wsx">libertad de verdad</strong>. Libertad para hacer un viaje en
            moto, para buscar a mis hijas al colegio, para estar cuando más me necesitan.
          </p>
          <p data-id="element-133" data-mp="7cg7163z4iro">Ahora quiero enseñarte el sistema exacto que uso para que vos también puedas elegir cómo vivir.</p>
        </div>
      </div>
    </section>;
}